import { FinancialSettingsContainer } from '@/modules/FinancialSettings';

const FinancialSettings = (): JSX.Element => <FinancialSettingsContainer />;

export default FinancialSettings;
